import {FormGroup, Label} from "reactstrap";
import {AvField, AvForm} from "availity-reactstrap-validation";
import React from "react";

const LimitTab = ({couponLimit, limitPerUser, limitPerProfessional, handleChange}) => {

  return <AvForm className="needs-validation row">
    <FormGroup className="col-md-12 col-lg-6">
      <Label htmlFor="validationCustom01">Лимит на употреба за купона</Label>
      <AvField
        name="couponLimit"
        placeholder="Лимит на купона"
        type="text"
        className="form-control"
        onChange={handleChange}
        value={couponLimit.toString()}
        id="validationCustom01"
      />
    </FormGroup>
    <FormGroup className="col-md-12 col-lg-6">
      <Label htmlFor="validationCustom01">Лимит на употреба за потребител</Label>
      <AvField
        name="limitPerUser"
        placeholder="Лимит за потребител"
        type="text"
        className="form-control"
        onChange={handleChange}
        value={limitPerUser.toString()}
        id="validationCustom01"
      />
    </FormGroup>
    <FormGroup className="col-md-12 col-lg-6">
      <Label htmlFor="validationCustom01">Лимит на употреба за специалист</Label>
      <AvField
        name="limitPerProfessional"
        placeholder="Лимит за специалист"
        type="text"
        className="form-control"
        onChange={handleChange}
        value={limitPerProfessional.toString()}
        id="validationCustom01"
      />
    </FormGroup>
  {/*  TODO: Text*/}
  </AvForm>

}

export default LimitTab
